export default __webpack_public_path__ + "static/media/10.885c52e5.webp";